import $ from 'jquery';
import BgLightHeader from './bg-light-header';
/* global x5script */

class PillarProjects {
  constructor() {
    this.projects = $('.js-pillar-project');

    if (!this.projects.length) {
      return;
    }

    this.bgLightHeader = new BgLightHeader();
    this.projectsToggle();
  }

  projectsToggle() {
    $.each(this.projects, (i, el) => {
      const project = $(el);
      const toggler = project.find('.js-pillar-project-toggle');
      const title = project.find('.js-pillar-project-title');
      const excerpt = project.find('.js-pillar-project-excerpt');
      const content = project.find('.js-pillar-project-full');
      const iconOpen = toggler.find('.js-pillar-project-toggle-open');
      const iconClose = toggler.find('.js-pillar-project-toggle-close');
      const togglerAriaLabelOpen = toggler.attr('aria-label');
      const togglerAriaLabelClose = `${
        x5script.projectShowLess
      } ${title.text()}`;

      toggler.on('click', () => {
        project.toggleClass('is-open');

        if (project.hasClass('is-open')) {
          excerpt.fadeOut(200, () => {
            content.slideDown(400, () => {
              this.bgLightHeader.init();
            });
            excerpt.attr('aria-hidden', true);
            content.attr('aria-hidden', false);
            iconOpen.hide();
            iconClose.show();
            toggler.attr('aria-label', togglerAriaLabelClose);
          });
        } else {
          content.slideUp(400, () => {
            excerpt.fadeIn(200);
            excerpt.attr('aria-hidden', false);
            content.attr('aria-hidden', true);
            iconOpen.show();
            iconClose.hide();
            toggler.attr('aria-label', togglerAriaLabelOpen);
            this.bgLightHeader.init();
          });
          $('body, html')
            .stop()
            .animate(
              {
                scrollTop: project.offset().top - 200,
              },
              400,
            );
        }
      });
    });
  }
}

export default new PillarProjects();



// WEBPACK FOOTER //
// ./src/scripts/modules/pillar-projects.js